var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"verify-invitation",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"md":"3"}}),_c('b-col',{attrs:{"md":"6"}},[_c('invitation-card')],1),_c('b-col',{attrs:{"md":"3"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }